import { api } from '@creditsights/api-ui-web';
import { toPascalCase } from '../../utils/stringUtils';
import { getCompanyId } from '../../utils/tagUtils';
import { SegmentGroup, FinancialsDto } from '../dtos/financials/financialsDto';

export const financialsModuleV1Uri = '/common/v1/financials';

export const toSegmentGroups = (financialsDto: FinancialsDto): SegmentGroup[] => {
  // Create a new array of segment groups adding the percentage field to each segment
  return (
    financialsDto.segment_data?.map((segmentData) => {
      // Sort the financials array in descending order based on value
      const sortedSegments = segmentData.segments.sort((a, b) => b.value - a.value);

      const values: number[] = [];
      const labels: string[] = [];
      sortedSegments.forEach(({ value, name }): void => {
        values.push(value);
        const percentage = Math.round((value / segmentData.segment_total) * 100);
        labels.push(`${toPascalCase(name)} ${percentage === 0 ? '<1' : percentage}%`);
      });

      return {
        title: segmentData.title,
        publishDate: financialsDto.published_date,
        values,
        labels,
      };
    }) || []
  );
};

export const fetchFinancials = async (companyId: string): Promise<FinancialsDto> => {
  const id = getCompanyId(companyId);
  const { data } = await api.get<FinancialsDto>(`${financialsModuleV1Uri}/${id}`);
  return data;
};
